import * as React from "react";
import ReactDOM from "react-dom";
import { RecipeSearch } from "./RecipeSearch";
import { Recipes } from "./Recipes";

ReactDOM.render(
  <RecipeSearch recipes={Recipes} />,
  document.querySelector("#root")
);
